export default "__VITE_ASSET__bf456e69__"